import * as React from "react"
import { Typography } from "@mui/material"


export default function CategoryText({ label, color="primary" }) {
    return <Typography variant="overline" sx={{ color: `${color}.main`}}>
        {label}
    </Typography>
}